import React, { useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { toast } from "sonner";
import { AI_TIERS } from "@/constants/aiTiersCatalog";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const ComplimentaryBillingForm = ({ user, onUpdated }) => {
  const [billingPlan, setBillingPlan] = useState(user.billing_plan || "stripe");
  const [aiTier, setAiTier] = useState(String(user.ai_tier || 1));
  const [expiresAt, setExpiresAt] = useState(
    user.complimentary_expires_at
      ? user.complimentary_expires_at.slice(0, 10)
      : ""
  );
  const [note, setNote] = useState(user.complimentary_note || "");
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const token = Cookies.get("token");
      const payload = {
        billing_plan: billingPlan,
        note: note.trim() || null,
      };
      if (billingPlan === "complimentary") {
        payload.ai_tier = Number(aiTier);
        payload.expires_at = expiresAt
          ? new Date(`${expiresAt}T23:59:59Z`).toISOString()
          : null;
      }
      const res = await axios.patch(
        `${BACKEND_URL}/api/admin/users/${user.id}/billing`,
        payload,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success("Billing updated");
      onUpdated(res.data);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Failed to update billing");
    } finally {
      setSaving(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4" data-testid="complimentary-billing-form">
      <div>
        <label className="block text-xs text-[#9CA3AF] mb-1">Billing plan</label>
        <select
          value={billingPlan}
          onChange={(e) => setBillingPlan(e.target.value)}
          className="w-full px-3 py-2 rounded-lg bg-white/5 border border-white/10 text-sm"
        >
          <option value="stripe">Stripe (paid)</option>
          <option value="complimentary">Complimentary (free)</option>
        </select>
      </div>

      {billingPlan === "complimentary" && (
        <>
          <div>
            <label className="block text-xs text-[#9CA3AF] mb-1">AI tier</label>
            <select
              value={aiTier}
              onChange={(e) => setAiTier(e.target.value)}
              className="w-full px-3 py-2 rounded-lg bg-white/5 border border-white/10 text-sm"
            >
              {AI_TIERS.map((tier) => (
                <option key={tier.id} value={tier.id}>
                  Tier {tier.id} — {tier.credits.toLocaleString()} credits/mo
                </option>
              ))}
            </select>
          </div>
          <div>
            <label className="block text-xs text-[#9CA3AF] mb-1">Expires (optional)</label>
            <input
              type="date"
              value={expiresAt}
              onChange={(e) => setExpiresAt(e.target.value)}
              className="w-full px-3 py-2 rounded-lg bg-white/5 border border-white/10 text-sm"
            />
          </div>
        </>
      )}

      <div>
        <label className="block text-xs text-[#9CA3AF] mb-1">Note</label>
        <textarea
          value={note}
          onChange={(e) => setNote(e.target.value)}
          rows={2}
          className="w-full px-3 py-2 rounded-lg bg-white/5 border border-white/10 text-sm resize-none"
          placeholder="Internal note (e.g. founder friend)"
        />
      </div>

      <button
        type="submit"
        disabled={saving}
        className="px-4 py-2 rounded-lg bg-[#00D1FF] text-[#0F1115] text-sm font-semibold hover:bg-[#00D1FF]/90 disabled:opacity-50"
      >
        {saving ? "Saving…" : "Save billing"}
      </button>
    </form>
  );
};

export default ComplimentaryBillingForm;
